module.exports = __webpack_public_path__ + "assets/img/34_708_big.0aa8253f.jpg";